import React, {ChangeEvent, useRef } from "react";
import "./Search.scss";
export interface Props {
  searchClass?: string;
  searchId?: string;
  searchPlaceholder?: string;
  searchClick?: () => void;
  searchValue?: string;
  searchChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  searchLabelText?: string;
  searchkeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  searchkeyUp?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  searchBtnText?: any;
  searchBtnClass?: string;
  searchBtnId?: string;
  children?: any;
  clearSearchList?: any;
}

const Search = ({
  searchClass,
  searchId,
  searchPlaceholder,
  searchClick,
  searchValue,
  searchChange,
  searchLabelText,
  searchkeyDown,
  searchkeyUp,
  searchBtnText,
  searchBtnClass,
  searchBtnId,
  children,
  clearSearchList,
}: Props) => {
  const searchRef = useRef<any>(null);
  const clearSearch = () => {
    if (searchRef?.current) {
      searchRef.current.value = "";
    }
  };
  return (
    <div className={`mfg-search${searchClass ? " " + searchClass : ""}`}>
      <div className={`search-container`}>
        {searchLabelText && <label htmlFor={searchId}>{searchLabelText}</label>}
        <input
          type="search"
          value={searchValue}
          onChange={searchChange}
          id={searchId && searchId}
          placeholder={searchPlaceholder}
          onKeyDown={searchkeyDown}
          onKeyUp={searchkeyUp}
          ref={searchRef}
        />
        {searchRef.current && !searchRef.current.value && (
          <button
            className={`srchBtn${searchBtnClass ? " " + searchBtnClass : ""}`}
            id={searchBtnId}
            onClick={searchClick}
          >
            {searchBtnText ? searchBtnText : "Search"}
          </button>
        )}
        {searchRef.current && searchRef.current.value && (
          <button
            className="clear-search"
            onClick={() => {
              if (clearSearch && clearSearchList) {
                clearSearch();
                clearSearchList();
              }
            }}
          >
            X
          </button>
        )}
      </div>
      {children && <div className="search-results">{children}</div>}
    </div>
  );
};

export default Search;
